var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.token)?_c('task-run',{attrs:{"token":_vm.token}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }